import React, { useMemo } from "react";
import { Box, Text } from "@dxp-feed/ui";
import { GlobalSearchSectionsType } from "@/utils/types/algolia";
import EmblaSlider from "../EmblaSlider";
import OfferCard from "../OfferCard";
import ArticleCard from "@/templates/articles/_components/ArticleCard";
import { RecipeCard } from "@/templates/recipes/_components/RecipeCard";
import { ArticleType } from "@/utils/types/article";
import { Product } from "@/utils/types/product";
import { RecipeType } from "@/utils/types/recipes";

interface CarouselProps {
  title: string;
  type: GlobalSearchSectionsType;
  items: Product[] | RecipeType[] | ArticleType[];
  slideCount: number;
}
const ResultsByPreferenceCarousel = ({
  title,
  type,
  items,
  slideCount = 5,
}: CarouselProps) => {
  const mappedData = useMemo(() => {
    const safeItems = Array.isArray(items) ? items : [];
    const data = slideCount ? safeItems.slice(0, slideCount) : safeItems;

    switch (type) {
      case "products":
        return (data as Product[]).map((item) => (
          <OfferCard key={item.objectID} item={item} />
        ));
      case "recipes":
        return (data as RecipeType[]).map((item) => (
          <RecipeCard key={item.objectID} item={item} list_name="Recipe List" />
        ));
      case "articles":
        return (data as ArticleType[]).map((item) => (
          <ArticleCard key={item.objectID} data={item} />
        ));
      default:
        return null;
    }
  }, [type, items, slideCount]);

  const finalSlidesPerView = useMemo(() => {
    return type === "products"
      ? { base: 1, sm: 2, md: 3, lg: 4, xl: 4, xxl: 5 }
      : { base: 1, sm: 2, md: 2, lg: 4, xl: 4, xxl: 4 };
  }, [type]);

  return (
    <Box className="results-by-preference-carousel px-[24px] 2md:px-0">
      <Box as="div" className="heading-wrapper pt-[24px] lg:pt-[32px]">
        <Box as="div" className=" flex justify-between items-center">
          <Text
            as="h2"
            className="heading text-left w-full flex-1 font-bold text-md xs:text-2xl"
          >
            {title}
          </Text>
        </Box>
      </Box>
      <Box
        as="div"
        className="md:pt-4 slider-wrapper mr-[-24px] md:mr-[-48px] lg:mr-0 pt-[16px]"
      >
        <Box as="div">
          <EmblaSlider
            align="start"
            options={{ loop: true, align: "start", dragFree: true }}
            slidesPerView={finalSlidesPerView}
            slidesToScroll={finalSlidesPerView}
            showControls={true}
            thumbnails={false}
            className={`roasterSlider [&_h3]:line-clamp-2 ${type}-slider`}
          >
            {mappedData}
          </EmblaSlider>
        </Box>
      </Box>
    </Box>
  );
};

export default ResultsByPreferenceCarousel;
